<div class="mat-drawer-content mat-sidenav-content">
  <section class="container">
    <mat-card class="migration-tasks">
      <mat-card-title>{{title}}</mat-card-title>
      <mat-card-subtitle>{{description}}</mat-card-subtitle>
    </mat-card>
  </section>

  @if (!migrationTasks) {
    <section class="container mat-sidenav-content">
      <div class="migrations-loading">
        <div class="spinner-wrapper">
          <mat-spinner class="mat-accent"></mat-spinner>
        </div>
        <br />
        <span>Loading maintenance tasks...</span>
      </div>
    </section>
  }

  <section class="container migrations" data-qa-id="maintenance-scheduler-section-tasks">
    @for (task of migrationTasks; track task; let i = $index) {
      <div class="task" [attr.data-qa-id]="'maintenance-scheduler-task-' + task.TaskTypeName">
        <maintenance-task [task]="task" [allTenants$]="allTenants$" (submit)="refreshSchedules()"></maintenance-task>
        @for (schedule of getSchedulesForTask(task); track schedule) {
          <div class="schedules">
            <maintenance-schedule [schedule]="schedule" [allTenants$]="allTenants$" (refreshRequested)="refreshSchedules()"></maintenance-schedule>
          </div>
        }
      </div>
    }
  </section>

  <section class="container recurring-series">
    <h3>Recurring schedules</h3>
    @for (series of recurringSeries$ | async; track series) {
      <maintenance-series-detail [series]="series" [allTenants$]="allTenants$" (changed)="refreshSchedules()"></maintenance-series-detail>
    }
  </section>
</div>
